//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import demandCard from "./components/demandCard";
import portal from "~/net/portal";
import "../../assets/styles/font.scss";

export default {
    components: { demandCard },
    data() {
        return {
            queryParam: {
                selectType: "",
                industryType: "",
                keyword: "",
                demandType: "",
                technologyType: "",
                intendedPrice: "",
                cooperationType: "",
                demandStatus: "",
                activityBrand: "",
                payCommission: "",
                activityYears: "2025",
                identityType: "",
                tagId: "",
                page: 1,
                row: 12
            },
            titleStrList: [
                "需求专栏",
                "重点企业",
                "省内企业",
                "新型研发机构",
                "区域需求",
                "战略性新兴产业",
                "未来产业",
                "新材料",
                "合成生物",
                "船舶与海洋工程装备",
                "高端装备",
                "新能源",
                "产业专场"
            ],
            titleTypeIndex: 0,
            links: [
                {
                    icon: require("../../assets/images/demand/link_icon_0.png"),
                    title: "专利/成果",
                    url:
                        "https://www.jstec.com.cn/search?page=1&rows=10&category=goods&goodsType=01&orderBy=BY_PUBLISH_TIME&orderSeq=DESC"
                },
                {
                    icon: require("../../assets/images/demand/link_icon_1.png"),
                    title: "店铺",
                    url: "https://www.jstec.com.cn/search?page=1&rows=10&category=shop"
                },
                {
                    icon: require("../../assets/images/demand/link_icon_2.png"),
                    title: "需求",
                    url:
                        "https://www.jstec.com.cn/search?page=1&rows=10&category=demand&demandType=03&orderBy=BY_PUBLISH_TIME&orderSeq=DESC"
                },
                {
                    icon: require("../../assets/images/demand/link_icon_3.png"),
                    title: "人才",
                    url: ""
                },
                {
                    icon: require("../../assets/images/demand/link_icon_4.png"),
                    title: "机构",
                    url: ""
                },
                {
                    icon: require("../../assets/images/demand/link_icon_5.png"),
                    title: "政策",
                    url:
                        "https://www.jstec.com.cn/search?page=1&rows=10&category=information&orderBy=BY_PUBLISH_TIME&orderSeq=DESC"
                }
            ],
            queryType: 0,
            filterList: [],
            filterTitleList: [],
            demandList: [],
            cooperationTypeList: [],
            demandTypeList: [],
            recommendDemandList: [],
            recommendPageList: [],
            latestDemandList: [],
            total: 0,
            queryTypeList: ["", "sortPublishTime", "sortHits", "sortResponse"],
            wlcyFilterList: [],
            zlxxcyFilterList: [],
            qycgFilterList: [],
            isRequest: false,
            sort: "01"
        };
    },
    watch: {
        queryType(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.keyword"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.demandRegion"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.industryType"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.demandType"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.technologyType"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.intendedPrice"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.cooperationType"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.demandStatus"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.activityBrand"(val) {
            if (val == "00") {
                this.queryParam.activityYears = "";
            }
            else {
              this.queryParam.activityYears = '2025';
            }
            this.getList();
        },
        "queryParam.payCommission"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.activityYears"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.tagId"(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        sort(val) {
            this.queryParam.page = 1;
            this.getList();
        },
        "queryParam.selectType"(val) {
            this.queryParam.tagId = "";
            this.queryParam.page = 1;
            this.getList();
        }
    },
    mounted() {
        this.queryParam.selectType = this.$route.query.selectType || "";
        this.titleTypeIndex = this.$route.query.type;
        this.queryParam.demandType = this.$route.query.demandType;
        this.getSysTags();
    },
    methods: {
        async getSysTags() {
            const { code, data } = await portal.selectSysTagsVo();
            if (code === "0000") {
                data.map((item) => {
                    if (item.tagType == "02") {
                        this.zlxxcyFilterList = item.sysTagVos;
                    } else if (item.tagType == "03") {
                        this.wlcyFilterList = item.sysTagVos;
                    } else {
                        this.qycgFilterList = item.sysTagVos;
                    }
                });
            }
            this.getFilter();
        },
        async getFilter() {
            const res = await portal.selectThemeDemandQueryCriteria();
            if (res.code == "0000") {
                this.filterList = [];
                this.filterTitleList = [];
                this.isRequest = true;
                if (res.data.demandType) {
                    this.demandTypeList = res.data.demandType;
                    this.filterList.push(res.data.demandType);
                    this.filterTitleList.push({
                        name: "需求类型",
                        key: "demandType"
                    });
                }
                if (res.data.technologyType) {
                    this.filterList.push(res.data.technologyType);
                    this.filterTitleList.push({
                        name: "技术领域",
                        key: "technologyType"
                    });
                }
                if (res.data.industryType) {
                    this.filterList.push(res.data.industryType);
                    this.filterTitleList.push({
                        name: "产业领域",
                        key: "industryType"
                    });
                }
                if (res.data.intendedPrice) {
                    this.filterList.push(res.data.intendedPrice);
                    this.filterTitleList.push({
                        name: "意向投入",
                        key: "intendedPrice"
                    });
                }
                if (res.data.cooperationType) {
                    this.filterList.push(res.data.cooperationType);
                    this.cooperationTypeList = res.data.cooperationType;
                    this.filterTitleList.push({
                        name: "合作方式",
                        key: "cooperationType"
                    });
                }
                if (res.data.demandStatus) {
                    this.filterList.push(res.data.demandStatus);
                    this.filterTitleList.push({
                        name: "需求状态",
                        key: "demandStatus"
                    });
                }
                if (res.data.activityBrand) {
                    this.filterList.push(res.data.activityBrand);
                    this.filterTitleList.push({
                        name: "品牌活动",
                        key: "activityBrand"
                    });
                    this.queryParam.activityBrand = "01";
                }
                if (res.data.payCommission) {
                    this.filterList.push(res.data.payCommission);
                    this.filterTitleList.push({
                        name: "服务佣金",
                        key: "payCommission"
                    });
                }
                if (res.data.activityYear) {
                    this.filterTitleList.push({
                        name: "活动年份",
                        key: "activityYears"
                    });
                    this.filterList.push(res.data.activityYear);
                }

                if (this.$route.query.industryType != "") {
                    this.queryParam.industryType = this.$route.query.industryType || "";
                    for (let i = 0; i < res.data.industryType.length; i++) {
                        const obj = res.data.industryType[i];
                        if (obj.dictCode == this.$route.query.industryType) {
                            this.titleTypeIndex = 7 + i;
                        }
                    }
                    this.selectType = "";
                }
            }
            this.isRequest = false;
            this.getList();
            this.getRecommendList();
            this.getLatestList();
        },
        async getList() {
            if (this.isRequest) return;
            this.isRequest = true;
            const body = Object.assign({}, this.queryParam);
            if (body.tagId == "202316900253462355") {
                body.tagId = "70";
            }
            if (this.queryType > 0) {
                body[this.queryTypeList[this.queryType]] = this.sort;
            }
            const res = await portal.selectThemeDemandPageQuery({
                body: this.queryParam
            });
            this.isRequest = false;
            if (res.code == "0000") {
                this.demandList = res.data.rows;
                this.total = res.data.total;
            } else {
                this.total = 0;
                this.demandList = [];
            }
        },
        async getRecommendList() {
            const res = await portal.selectThemeDemandRecommendPageQuery({
                query: {
                    page: 1,
                    row: 100
                }
            });
            if (res.code == "0000") {
                this.recommendDemandList = res.data.rows;
                this.recommendPageList = this.chunk(res.data.rows, 6);
            }
        },
        chunk(arr, size) {
            const arr2 = [];
            for (let i = 0; i < arr.length; i = i + size) {
                arr2.push(arr.slice(i, i + size));
            }
            return arr2;
        },
        async getLatestList() {
            const res = await portal.selectThemeDemandLatestQuery();
            if (res.code == "0000") {
                this.latestDemandList = res.data;
            }
        },
        change(page) {
            this.queryParam.page = page;
            this.getList();
        },
        getCooperationType(val) {
            console.log(val);
            if (val && this.cooperationTypeList.length > 0) {
                const obj = this.cooperationTypeList.find((_) => {
                    return _.dictCode == val;
                });
                if (obj) {
                    return obj.dictName;
                }
            }
            return "";
        },
        getDemandType(val) {
            if (val && this.demandTypeList.length > 0) {
                return this.demandTypeList.find((_) => {
                    return _.dictCode == val;
                }).dictName;
            }
            return "";
        },
        jump(url) {
            if (url) {
                window.open(url);
            }
        },
        pushToDemandDetail(val) {
            this.$router.push(
                `/crowdsourcing/demandDetail?id=${val.demandId}&root=${this.$route.query.root}`
            );
        }
    }
};
